import * as general from "./general"

export const langHelper = {
  general,
}
